var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.17867 0 0 7.17867 0 16C0 24.8213 7.17867 32 16 32C24.8213 32 32 24.8213 32 16C32 7.17867 24.8213 0 16 0ZM16 2.66667C23.38 2.66667 29.3333 8.62 29.3333 16C29.3366 19.192 28.192 22.2787 26.1085 24.6968C24.0249 27.1149 21.1414 28.7033 17.984 29.172V19.888H21.7813L22.3773 16.0307H17.984V13.924C17.984 12.324 18.5107 10.9013 20.008 10.9013H22.4147V7.536C21.992 7.47867 21.0973 7.35467 19.4067 7.35467C15.876 7.35467 13.8067 9.21867 13.8067 13.4667V16.0307H10.1773V19.888H13.8067V29.1387C10.693 28.6262 7.86298 27.0233 5.82226 24.6165C3.78153 22.2096 2.66305 19.1556 2.66667 16C2.66667 8.62 8.62 2.66667 16 2.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.dace94309836907fbdca2874e35f7158.svg";
export { ForwardRef as ReactComponent };